/* eslint-disable default-param-last */
/**
 * @description Ações relacionadas a definição do state da aplicação
 * @author Bene Lemuel Dantas Gondim
 * @file vestigiosGenericoReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import * as actionTypes from 'actions'
import types from 'utils/actionTypes'
// Estado inicial da sessão no redux
const initialState = {
  vestigiosCentralCustodia: [],
  vestigioTimeLine: {},
  vestigiosAReceberCentralCustodia: [],
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    __t: '',
    tipoVestigioGenerico: '',
    identificador: '',
    tipo: '',
    descricao: '',
    delegaciaResponsavel: '',
    delegadoSolicitante: '',
    orgaoReceptor: '',
    setorAtual: '',
    localOrigem: '',
    cadeiaDeCustodia: '',
    deletado: false,
  },
}
const vestigiosGenericoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_VESTIGIO_TIMELINE: {
      return {
        ...state,
        vestigioTimeLine: action.vestigioTimeLine,
      }
    }

    case actionTypes.FETCH_VESTIGIOS_CENTRAL_CUSTODIA: {
      return {
        ...state,
        vestigiosCentralCustodia: action.vestigiosCentralCustodia,
      }
    }

    case actionTypes.FETCH_VESTIGIOS_A_RECEBER_CENTRAL_CUSTODIA: {
      return {
        ...state,
        vestigiosAReceberCentralCustodia: action.vestigiosAReceberCentralCustodia,
      }
    }

    case actionTypes.SET_PROCESSANDO_FETCH_VESTIGIOS_CENTRAL_CUSTODIA: {
      return {
        ...state,
        processandoVestigiosCentralCustodia: action.isProcessandoVestigiosCentralCustodia,
      }
    }

    case actionTypes.VESTIGIO_SUCESSO: {
      return {
        ...state,
        nomeFuncao: action.nomeFuncao,
        dados: {
          id: action.dados.id,
        },
      }
    }

    case actionTypes.VESTIGIO_ERROR: {
      return {
        ...state,
        error: action.dados,
        nomeFuncao: action.nomeFuncao,
      }
    }

    default: {
      return state
    }
  }
}

export default vestigiosGenericoReducer
